<template>
    <b-row>
        <b-col cols="12">
            <b-card>
                <header class="d-md-flex justify-content-md-between align-items-center">
                    <h5>Invitaciones para los abonados</h5>
                </header>
                <hr/>
                <b-card-text>
                    <b-row>
                        <b-col cols="12" class="mb-3">
                            <SearchComponent v-model="filters.search" @input="getInvitaciones" />
                        </b-col>
  
                        <b-col cols="12" class="mb-3">
                            <b-form-checkbox v-model="applyToAll">
                                Aplicar cambios a todos
                            </b-form-checkbox>
                        </b-col>
  
                        <b-col cols="12">
                            <b-table
                                responsive
                                :busy="loading"
                                show-empty 
                                :items="invitaciones.data"
                                :fields="fields"
                                empty-text="No se han encontrado tipos de abonos"
                            >
                                <template #cell(cambiar_cantidad)="{ item }">
                                    <div class="number-input">
                                        <button class="btn-circle" @click="decrement(item)">−</button>
                                        <input
                                            type="number"
                                            v-model.number="item.n_invitaciones_abonados"
                                            min="0"
                                            class="form-control text-center border-bottom-0 p-2"
                                            @input="onInput(item)"
                                        />
                                        <button class="btn-circle" @click="increment(item)">+</button>
                                    </div>
                                </template>
                            </b-table>
                        </b-col>
                    </b-row>
                    <hr/>
                    <div class="row">
                        <div class="col-12 d-flex justify-content-end">
                            <button class="button" @click="modificarCantidad">Guardar</button>
                        </div>
                    </div>
                    <hr/>
                    <div class="row justify-content-between">
                        <div class="col-md-6 col-sm-12">                               
                            <ElementosPorPaginaComponent 
                                v-model="filters.per_page"
                                @input="changePerPage"
                            />
                        </div>
                        <div class="col-md-6 col-sm-12" v-if="invitaciones">
                            <PaginateComponent 
                                :current_page="invitaciones.meta.current_page" 
                                :last_page="invitaciones.meta.last_page"
                                v-on:change_page="setPage"
                            />
                        </div>
                    </div>
                </b-card-text>
            </b-card>
        </b-col>
    </b-row>
</template>
  
  <script>
    import ElementosPorPaginaComponent from "@/components/backend/components/ElementosPorPaginaComponent";
    import PaginateComponent from "@/components/table/pagination/BackPaginateComponent";
    import SearchComponent from '@/components/backend/components/SearchComponent';
  
    export default {
        data() {
            return {
                invitaciones: { data: [], meta: { current_page: 1 } }, 
                originalInvitaciones: [],
                filters: {
                    per_page: 10,
                    page: 1,
                    search: '',
                    all: 1
                },
                fields: [
                    { key: 'descripcion', label: 'Descripción' },
                    { key: 'cambiar_cantidad', label: 'Invitaciones disponibles' },
                ],
                loading: false,
                applyToAll: false,
            }
        },
        computed: {
            lista() {
                return this.$store.getters.getListaId;
            }
        },
        watch: {
            applyToAll(newValue) {
                if (!newValue) {
                    this.invitaciones.data = this.originalInvitaciones.map(item => ({ ...item }));
                }
            }
        },
        created() {
            this.getInvitaciones();
        },
        methods: {
            setPage(page) {
                this.filters.page = page;
                this.getInvitaciones();
            },
            getInvitaciones() {
                this.loading = true;
                const params = { filters: this.filters, lista_id: this.lista };
  
                this.$store.dispatch(this.config.getVuexAlias('back.abonados.lista.invitaciones'), params)
                    .then(res => {
                        this.invitaciones = res.data;
                        this.originalInvitaciones = this.invitaciones.data.map(item => ({
              ...item,
              cantidad: item.n_invitaciones_abonados
                        }));
                    })
                    .finally(() => { this.loading = false; });
            },
            modificarCantidad() {
                this.loading = true;
                const params = {
                    lista_id: this.lista,
                    tipos: this.invitaciones.data
                };
  
                this.$store.dispatch(this.config.getVuexAlias('back.abonados.lista.invitaciones-actualizar'), params)
                    .then(() => {
                        this.$toast.success('Cambios guardados correctamente');
                        this.getInvitaciones();
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            changePerPage(per_page) {
                this.filters.per_page = per_page;
                this.getInvitaciones();
            },
            increment(item) {
                item.n_invitaciones_abonados++;
                if (this.applyToAll) this.applyToAllItems(item.n_invitaciones_abonados);
            },
            decrement(item) {
                item.n_invitaciones_abonados = Math.max(0, item.n_invitaciones_abonados - 1);
                if (this.applyToAll) this.applyToAllItems(item.n_invitaciones_abonados);
            },
            onInput(item) {
                if (this.applyToAll) this.applyToAllItems(item.n_invitaciones_abonados);
            },
            applyToAllItems(value) {
                this.invitaciones.data.forEach(i => i.n_invitaciones_abonados = value);
            }
        },
        components: {
            ElementosPorPaginaComponent, PaginateComponent, SearchComponent
        }
    }
  </script>
  
  <style scoped>
  .number-input {
    display: flex;
    align-items: center;
    margin-left: 25px;
  }
  
  .number-input input {
    width: 60px;
    text-align: center;
  }
  
  .btn-circle {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    border: 1px solid #0056b3;
    color: #0056b3;
    font-size: 18px;
    font-weight: bold;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .btn-circle:hover {
    background-color: #0057b342;
  }
  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  
  input[type=number] {
    -moz-appearance: textfield;
  }
  </style>
  